import type { AdminPulseData } from "@shared/schema";
import { getActiveStatus } from "@/lib/budget-utils";

interface BudgetPulseDetailProps {
  adminData: AdminPulseData;
}

export function BudgetPulseDetail({ adminData }: BudgetPulseDetailProps) {
  if (adminData.subType !== "budgeting" || !adminData.budgeting?.items?.length) return null;

  return (
    <div className="ml-7 mr-3 -mt-0.5 mb-0.5 space-y-0.5">
      {adminData.budgeting.items.map((item, idx) => {
        const status = getActiveStatus(item);
        return (
          <div key={item.id || idx} className="flex items-center gap-2 text-xs">
            <span className="text-gray-200 font-medium truncate flex-1 min-w-0" title={item.label}>
              {item.type === 'bid' ? 'B' : 'I'} | {item.label}
            </span>
            <span className={`px-1.5 py-0 rounded text-[9px] font-semibold flex-shrink-0 ${status.color}`}>
              {status.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
